import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CallBackTransformService {

  constructor() { }

  /**
   * Function to trim white space before submit
   * @param any data
   */
  removeSpaces(data) {
    // tslint:disable-next-line: forin
    for (const item in data) {
      const type = typeof data[item];
      if (type === 'string') {
        const value: string = data[item];
        data[item] = value.trim();
      }
    }
    return data;
  }

  /**
 * Frunction to transform the response data
 * @param dataObj : response data object
 */
  transformOutput(dataObj) {
    const responseData = {
      StatusCode: '',
      Message: '',
      Data: '',
      responseMessage:'',
      version: ''
    };
    if (dataObj.statusCode === 200) {
      responseData.Message = dataObj.result.responseStatus;
      responseData.Data = dataObj.result;
      responseData.StatusCode = dataObj.statusCode;
      responseData.responseMessage = dataObj.message;
      responseData.version = dataObj?.version;
    } else {
      if (dataObj.statusCode === 422) {
        responseData.Data = dataObj?.error?.exceptionMessage;
      }
      responseData.Message = dataObj.error && dataObj.error.exceptionMessage && dataObj.error.exceptionMessage.title
                              ? dataObj.error.exceptionMessage.title : 'A network related error has been occurred. Please try again!';
      responseData.StatusCode = dataObj.statusCode;
    }
    return responseData;
  }

  transFormColorData(data){
    console.log('data: ', data);

  }
}
